import { connector } from "utils/common/connector";

const controller = "sensitiveCustomerInformation";

// ---------------------------------------------
// GET PAGINATED SENSITIVE CUSTOMER INFORMATION
// ---------------------------------------------
export const getSensitiveCustomerInformationService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getSensitiveCustomerInformation",
      params,
    );

    reply = {
      sensitiveCustomerInformation:
        response?.sensitiveCustomerInformation ?? [],
      totalSensitiveCustomerInformation: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      sensitiveCustomerInformation: [],
      totalSensitiveCustomerInformation: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// GET SENSITIVE INFORMATION BY ID
// ---------------------------------------------
export const getSensitiveCustomerInformationByIdService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getSensitiveCustomerInformationById",
      params,
    );

    reply = response ?? {};
  } catch (error) {
    console.log(error);
    reply = {};
  }

  return reply;
};

// ---------------------------------------------
// CHECK INFORMATION (BIN)
// ---------------------------------------------
export const checkSensitiveInformationService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "checkInformation",
      params,
    );

    reply = response ?? {};
  } catch (error) {
    console.log(error);
    reply = {};
  }

  return reply;
};

// ---------------------------------------------
// CREATE SENSITIVE CUSTOMER INFORMATION
// ---------------------------------------------
export const createSensitiveCustomerInformationService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "create", params);

    reply = response ?? { success: false };
  } catch (error) {
    console.log(error);
    reply = { success: false };
  }

  return reply;
};

// ---------------------------------------------
// UPDATE SENSITIVE CUSTOMER INFORMATION
// ---------------------------------------------
export const updateSensitiveCustomerInformationService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "update", params);

    reply = response ?? {};
  } catch (error) {
    console.log(error);
    reply = {};
  }

  return reply;
};
